import styled from "styled-components";

export const TemplateWrapper = styled.div<{ isEmpty: boolean }>`
  margin-top: 20px;
  width: calc(100% - 40px);
  height: 654px;
  padding: 20px;

  display: ${(props) => (props.isEmpty ? "flex" : "grid")};
  ${({ isEmpty }) => isEmpty && "flex-direction: column;"}
  ${({ isEmpty }) => isEmpty && "align-items: center;"}
  ${({ isEmpty }) => isEmpty && "justify-content: center;"}
  ${({ isEmpty }) => !isEmpty && "grid-template-columns: repeat(3, 1fr);"}
  gap: 12px;
  overflow-y: auto;
  overflow-x: hidden;

  border-radius: 20px;
  background: #f0f0f0;

  color: #444;
  text-align: center;
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const TemplateItem = styled.div<{ image: string; selected: boolean }>`
  width: 245.322px;
  height: 346.745px;
  background-image: url(${(props) => props.image});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border: ${(props) => (props.selected ? "2px solid #6436E7" : "none")};
  border-radius: 13px;
`;
